import { setType } from '@/common/utils/typedValueSerializer'
import UniDataTableRow from './UniDataTableRow'

interface SelectedData {
  selectedFields?: Record<string, any>
}

function unwrapConstructValue(value: unknown): unknown {
  if (
    value != null &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    'value' in (value as object) &&
    'type' in (value as object)
  ) {
    return (value as { value: unknown }).value
  }
  return value
}

/**
 * Fat-client / platform `UniDataTools.constructRow(k1, v1, …)` или `constructRow([k1, v1, …])`.
 */
function normalizeConstructPairs(args: unknown[]): unknown[] {
  if (args.length === 1 && Array.isArray(args[0])) {
    return args[0] as unknown[]
  }
  return args
}

export default class UniDataTools {
  static toRow(data: SelectedData): UniDataTableRow {
    return new UniDataTableRow({ fields: data.selectedFields })
  }

  static constructRow(...args: unknown[]): UniDataTableRow {
    const pairs = normalizeConstructPairs(args)
    const fields: Record<string, { value: any; type?: string }> = {}
    for (let i = 0; i + 1 < pairs.length; i += 2) {
      const key = String(pairs[i] ?? '')
      if (!key) continue
      const raw = unwrapConstructValue(pairs[i + 1])
      fields[key] = setType(raw)
    }
    return new UniDataTableRow({ fields })
  }
}
